export type ToastKind = 'success' | 'error' | 'warning';

export interface ToastItem {
  id: number;
  kind: ToastKind;
  message: string;
}

type ToastListener = (toasts: ToastItem[]) => void;

class ToastService {
  private toasts: ToastItem[] = [];
  private listeners: ToastListener[] = [];
  private nextId = 1;

  subscribe(listener: ToastListener): () => void {
    this.listeners.push(listener);
    listener(this.toasts);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  success(message: string, durationMs = 3000): number {
    return this.show('success', message, durationMs);
  }

  error(message: string, durationMs = 4000): number {
    return this.show('error', message, durationMs);
  }

  warning(message: string, durationMs = 4000): number {
    return this.show('warning', message, durationMs);
  }

  clear(): void {
    this.toasts = [];
    this.notify();
  }

  private show(kind: ToastKind, message: string, durationMs: number): number {
    const id = this.nextId++;
    this.toasts = [...this.toasts, { id, kind, message }];
    this.notify();

    setTimeout(() => {
      this.toasts = this.toasts.filter(toast => toast.id !== id);
      this.notify();
    }, durationMs);

    return id;
  }

  private notify(): void {
    this.listeners.forEach(listener => listener(this.toasts));
  }
}

export const toastService = new ToastService();
